exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".donateButton___3i9f7 {\n  min-width: 10rem;\n}\n.donateButton___3i9f7:disabled {\n  cursor: not-allowed;\n}\n.tickerBox___5DgG6 {\n  margin-top: 24px;\n  margin-bottom: -24px;\n}\n.tickerBox___5DgG6 .tickerText___kHb-Y {\n  padding-top: 4px;\n}\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/causefundraisernodeweb-ci-release/public/js/components/HeroModule.less"],"names":[],"mappings":"AAAA;EACE,iBAAiB;CAClB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,iBAAiB;EACjB,qBAAqB;CACtB;AACD;EACE,iBAAiB;CAClB","file":"HeroModule.less","sourcesContent":[".donateButton {\n  min-width: 10rem;\n}\n.donateButton:disabled {\n  cursor: not-allowed;\n}\n.tickerBox {\n  margin-top: 24px;\n  margin-bottom: -24px;\n}\n.tickerBox .tickerText {\n  padding-top: 4px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"donateButton": "donateButton___3i9f7",
	"tickerBox": "tickerBox___5DgG6",
	"tickerText": "tickerText___kHb-Y"
};